/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

angular.module("promotions")
  // count of items which used in rule selectors
  .constant("ruleSelectorLimit", 100)
  // rule selectors names
  .constant("ruleSelectors", ['products', 'tags', 'providers', 'options', 'operations'])
  // discount types which require value
  .constant("valueRequired", ['fixed', 'flat', 'ratio', 'percent', 'release', 'markup'])
  /**
   * @ngdoc controller
   * @name promotionCtrl
   * @requires $scope, $aside, $modalInstance, $location, $filter, $timeout, $q, b17Service, userCache, auth, selector, currencyMap
   *
   * @description
   * Promotion Controller
   */
  .controller("promotionCtrl", function (
    $scope, $aside, $modalInstance, $location, $filter, $timeout, $q,
    b17Service, userCache, auth, selector, promotion, currencyMap,
    ruleSelectorLimit, ruleSelectors, valueRequired, pricePattern
  ) {

    var isApprove = false;

    $scope.location = $location.path();

    // limit of rule selector
    $scope.ruleSelectorLimit = ruleSelectorLimit;

    // init condition type selector
    $scope.conditionType = 'Custom';

    // init standard condition type selector
    $scope.standardConditionType = 'Counter';

    // add form patterns
    $scope.pricePattern = pricePattern;
    $scope.counterPattern = '\\d{1,9}';
    $scope.markupValuePattern = /^-?\d+(.\d+)?$/;

    // init error and info messages
    $scope.errorMessage = null;
    $scope.infoMessage = null;

    // save/deactivate message
    $scope.saveMessage = 'Save as not approved';
    if (promotion && promotion.active) {
      $scope.saveMessage = 'Deactivate and save';
    }

    // init tabs
    $scope.tabs = [
      {
        index: null,
        active: true,
        title: 'Promotion rules',
      },
      {
        index: null,
        active: false,
        title: 'Global conditions',
      },
    ];

    // controller scope data
    $scope.data = {};

    // init original promotion item
    if (promotion) {
      $scope.data.promotion = angular.copy(promotion);
      if (promotion.bind) {
        $scope.tabs[1].title = 'Personal conditions';
      }
      if (!promotion.rules) {
        $scope.data.promotion.rules = [];
      }
    } else {
      // create new promotion item
      $scope.data.promotion = {
        version: userCache.get('promotionListSelectedVersion'),
        period: {},
        rules: [],
      };
    }
    // init condition type selector
    $scope.selectConditionType = function (name) {
      $scope.conditionType = name;
    };

    // getter of condition type
    $scope.getConditionType = function () {
      return $scope.conditionType;
    };

    // init standard condition type selector
    $scope.selectStandardConditionType = function (name) {
      $scope.standardConditionType = name;
    };

    // getter of standard condition type
    $scope.getStandardConditionType = function () {
      return $scope.standardConditionType;
    };

    $scope.listOfCurrencies = Object.keys(currencyMap);

    // ----------------
    // DATES PROCESSING
    // ----------------

    // use date and time 00:00:00
    var currentDate = new Date();
    var timezone = (currentDate.getTimezoneOffset() < 0 ? '+' : '-') +
      _.padLeft(Math.abs(currentDate.getTimezoneOffset() / 60), 2, '0');
    console.log(timezone);
    $scope.currentDate = new Date(
      currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate()
    );
    $scope.dateFrom = ($scope.data.promotion.period && $scope.data.promotion.period.from) ?
      new Date(
        $scope.data.promotion.period.from + 'T' +
        ($scope.data.promotion.period.start ? $scope.data.promotion.period.start : '00:00:00') + timezone + ':00'
      ) : null;
    $scope.dateTo = ($scope.data.promotion.period && $scope.data.promotion.period.to) ?
      new Date(
        $scope.data.promotion.period.to + 'T' +
        ($scope.data.promotion.period.stop ? $scope.data.promotion.period.stop : '23:59:59') + timezone + ':00'
      ) : null;
    $scope.minDate = angular.copy($scope.currentDate);

    // Open Date Picker when the promotion start
    $scope.openDatePickerFrom = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.openedFrom = true;
    };

    // Open Date Picker when the promotion stop
    $scope.openDatePickerTo = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.openedTo = true;
    };
    // setup initial date picker options
    $scope.dateOptions = {
      startingDay: 1,
      showWeeks: false,
    };

    // watch $scope.dateFrom and prepare it to save
    $scope.$watch('dateFrom', function(newValue) {
      $scope.data.promotion.period.from = $filter("date")(newValue, "yyyy-MM-dd");
      $scope.data.promotion.period.start = $filter("date")(newValue, "HH:mm:ss");
      if ($scope.data.promotion.period.start === "00:00:00") {
        $scope.data.promotion.period.start = "";
      }
    });

    // watch $scope.dateTo and prepare it to save
    $scope.$watch('dateTo', function(newValue, oldValue) {
      $scope.data.promotion.period.to = $filter("date")(newValue, "yyyy-MM-dd");
      $scope.data.promotion.period.stop = $filter("date")(newValue, "HH:mm:ss");
      if (oldValue === null && $scope.data.promotion.period.stop === "00:00:00") {
        $scope.dateTo = new Date($scope.data.promotion.period.to + 'T23:59:59' + timezone + ':00');
        $scope.data.promotion.period.stop = "";
      }
      if ($scope.data.promotion.period.stop === "23:59:59") {
        $scope.data.promotion.period.stop = "";
      }
    });

    // split description to 2 parts: short and long
    $scope.splitDescription = function(description, length) {
        var descriptionParts = description.split('-').map(function(d){
            return d.trim();
        });
        return {
            short: descriptionParts[0],
            long: descriptionParts.length > 1 ? descriptionParts[1] : ''
        };
    };

    // -------------
    // GET REST DATA
    // -------------

    // Get b17 config
    b17Service.getConfig().then(function (config) {
      if (config.data && config.data.data) {
        $scope.data.config = config.data.data.results[0];
      } else {
        checkErrorCodeMessage();
      }
    });

    // get b17 discounts
    b17Service.getDiscounts().then(function (discounts) {
      if (discounts.data && discounts.data.data) {
        $scope.data.discounts = discounts.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // get b17 conditions
    b17Service.getConditions().then(function (conditions) {
      if (conditions.data && conditions.data.data) {
        $scope.data.conditions = conditions.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // get b17 groups
    b17Service.getGroups().then(function (groups) {
      if (groups.data && groups.data.data) {
        $scope.data.groups = groups.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // get b17 products
    b17Service.getProducts().then(function (products) {
      if (products.data && products.data.data) {
        $scope.data.products = products.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // get b17 prices
    b17Service.getPrices({legacy: 'true'}).then(function (prices) {
      if (prices.data && prices.data.data) {
        $scope.data.prices = prices.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    if (promotion && promotion.id) {
      // renew promotion data
      b17Service.getPromotions(
        {
          cache: false,
          id: promotion.id,
        }).then(function (promotion) {
          if (promotion.data && promotion.data.data) {
            $scope.data.promotion = promotion.data.data.results[0];
          } else {
            checkErrorCodeMessage();
          }
        }
      );

      // renew condition and counter of promo
      if (promotion.condition) {
        b17Service.getConditions(
          {
            cache: false,
            name: promotion.condition,
          }).then(function (condition) {
            if (!condition.data || !condition.data.data) {
              checkErrorCodeMessage();
              return;
            }
            $scope.data.condition = condition.data.data.results[0];
            $scope.data.condition.rules.forEach(function (rule) {
              if (rule.relation.indexOf('_with_counter') === -1) {
                return;
              }
              $scope.data.counter = rule.value;
            });
          }
        );
      } else {
        $scope.data.condition = null;
        $scope.data.counter = null;
      }
    }

    // ---------
    // SELECTORS
    // ---------

    // select group
    $scope.selectGroup = function (index, group) {
      $scope.tabs.forEach(function(item, idx) {
        if (item.index === index) {
          item.content.group = group;
          ruleSelectors.forEach( function(type) {
            selector.setContent(index, type, getRuleContent(type, group), selector.get(index, type) || []);
          });
        }
      });
    };

    // select discount
    $scope.selectDiscount = function (index, discount) {
      $scope.tabs.forEach(function(item, idx) {
        if (item.index === index) {
          if (discount === 'tier') {
            item.content.value = $scope.data.config.tiers[0];
          } else {
            item.content.value = null;
          }
          item.content.discount = discount;
        }
      });
    };

    // select markup currency
    $scope.selectMarkupCurrency = function (index, currency) {
      $scope.tabs.forEach(function(item, idx) {
        if (item.index === index) {
          item.content.value.currency = currency;
        }
      });
    };

    // select condition
    $scope.selectCondition = function (condition) {
      $scope.data.promotion.condition = condition;
      $scope.data.counter = null;
    };

    // clear condition
    $scope.clearCondition = function () {
      $scope.data.promotion.condition = '';
      $scope.data.counter = null;
    };

    // select tier
    $scope.selectTier = function (index, tier) {
      $scope.tabs.forEach(function(item, idx) {
        if (item.index === index) {
          item.content.value = tier;
        }
      });
    };

    // -------
    // FILTERS
    // -------

    $scope.conditionFilter = function (item) {
      return item.name.indexOf('old') === -1 &&
        item.name.indexOf('test') === -1 &&
        item.name !== 'tier' &&
        item.name !== 'counter' &&
        item.name.indexOf('personal') !== 0 &&
        item.name.indexOf('_with_counter') === -1;
    };

    // -------------
    // RULE CONTROL
    // -------------

    // edit rule by index
    $scope.editRule = function(index) {

      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      // restrict to open more than three rules
      if ($scope.tabs.length >= 5) {
        $scope.errorMessage = 'Could not open more than three rules at the same time.';
        return;
      }

      if ($scope.tabs.every( function(item) {
        return item.index != index;
      })) {
        var tab = {
          index: index,
          active: true,
          title: 'Edit rule #' + (index+1),
          content: angular.copy($scope.data.promotion.rules[index]),
        };
        ruleSelectors.forEach( function(type) {
          selector.setContent(
            index,
            type,
            getRuleContent(type, $scope.data.promotion.rules[index].group),
            $scope.data.promotion.rules[index][type === 'options' ? 'articles' : type] || []
          );
        });
        $scope.tabs.push(tab);
      } else {
        $scope.tabs.forEach(function(item) {
          if (item.index === index) {
            item.active = true;
          }
        });
      }
    };

    // delete rule by index
    $scope.deleteRule = function(index) {

      // clear error messages
      $scope.dismissError();

      // check if tabs are opened
      if ($scope.tabs.length > 2) {
        $scope.errorMessage = 'Please close all opened tabs before deleting any rule.';
        return;
      }

      $scope.data.promotion.rules.splice(index, 1);
    };

    // add rule
    $scope.addRule = function($event) {

      $event.preventDefault();
      $event.stopPropagation();

      var index = $scope.data.promotion.rules.length;

      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      // restrict to open more than three rules
      if ($scope.tabs.length >= 5) {
        $scope.errorMessage = 'Could not open more than three rules at the same time.';
        return;
      }

      if ($scope.tabs.every( function(item) {
        return item.index != index;
      })) {
        var tab = {
          index: index,
          active: true,
          title: 'Add rule #' + (index+1),
          content: {
            discount: 'cost',
          },
        };
        ruleSelectors.forEach( function(type) {
          selector.setContent(index, type, getRuleContent(type, null), []);
        });
        $scope.tabs.push(tab);
      } else {
        $scope.tabs.forEach(function(item) {
          if (item.index === index) {
            item.active = true;
          }
        });
      }
    };

    // check if the discount uses the default value
    $scope.isDefaultRuleValue = function (discount) {
      var discounts = ['fixed', 'flat', 'percent', 'ratio'];
      return discounts.includes(discount);
    };
    
    // apply rule by index
    $scope.applyRule = function (index) {

      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();
     
      // possible promo values
      var values = [
        'value', 'value-tier-1', 'value-tier-2', 'value-tier-3', 'value-tier-4', 'value-tier-5', 
        'value-tier-6', 'value-tier-7', 'value-tier-8', 'value-cost', 'value-extras', 'markup-value'
      ];

      values.forEach(function (value) {
        var promoFormField = $scope.promotionForm[value];
        if (promoFormField && promoFormField.$invalid && promoFormField.$error.required) {
          $scope.errorMessage = "Please complete required fields.";
          return;
        } 
        if (promoFormField && promoFormField.$invalid && promoFormField.$error.pattern) {
          $scope.errorMessage = "Please complete fields correctly.";
          return;
        }
      });

      if ($scope.errorMessage !== null) {
        return;
      }

      $scope.tabs.forEach( function (item, key) {
        if (item.index === index) {
          if (!item.content.group) {
            $scope.errorMessage = "Please select a rule group field.";
            return;
          }
          if (!$scope.data.promotion.rules[index]) {
            $scope.data.promotion.rules[index] = {};
          }
          $scope.data.promotion.rules[index].group = item.content.group;
          ruleSelectors.forEach( function (type) {
            $scope.data.promotion.rules[index][type === 'options' ? 'articles' : type] = selector.get(index, type);
          });
          $scope.data.promotion.rules[index].quantity = item.content.quantity || null;
          $scope.data.promotion.rules[index].discount = item.content.discount;
          $scope.data.promotion.rules[index].value = item.content.value;
          $scope.tabs.splice(key, 1);
          selector.removeContent(index);
          $timeout(function() {
            $scope.tabs[0].active = true;
          });
        }
      });
    };

    // discard rule changes by index
    $scope.discardRule = function (index) {

      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      $scope.tabs.forEach( function (item, key) {
        if (item.index === index) {
          $scope.tabs.splice(key, 1);
          selector.removeContent(index);
          if ($scope.tabs.length < 3) {
            $timeout(function() {
              $scope.tabs[0].active = true;
            });
          }
        }
      });
    };

    // ------------
    // BIND CONTROL
    // ------------

    // verify clients/resellers ID's
    $scope.verifyBind = function () {

      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      // just return if empty bind
      if (!$scope.data.promotion.bind) {
        $scope.data.promotion.bind = null;
        return $q.when(true);
      }

      // transform/filter array/string of ID's into array
      var bind = transformElements(angular.copy($scope.data.promotion.bind));

      // return if empty bind
      if (bind.length === 0) {
        return $q.when(true);
      }

      // init pool of existing clients/resellers ID's
      var success = [];

      // create keys to check dups
      var keys = [];

      // check all clients/resellers ID's
      return $q.all([].map.call(bind, function(item) {
        return b17Service.getClients({id: item});
      })).then(function (results) {

        // check all results of clients/resellers ID's
        results.forEach( function(result) {
          if (result.data && result.data.data) {
            if (result.data.data.success &&
              angular.isUndefined(keys[result.data.data.results[0].id])) {

              keys[result.data.data.results[0].id] = true;
              // collect all success ID's
              success.push(result.data.data.results[0].id);
            }
          } else {
            checkErrorCodeMessage();
          }
        });

        // check failed clients/resellers ID's
        var failed = [];
        bind.forEach( function(item) {
          if (angular.isUndefined(keys[item]) && success.indexOf(item) === -1) {
            keys[item] = true;
            // collect all failed ID's
            failed.push(item);
          }
        });

        if (failed.length > 0) {
          $scope.errorMessage = "Incorrect Clients/Resellers ID's: " + failed.join(', ');
          // activate condition tab
          $scope.tabs[1].active = true;
          return false;
        } else {
          $scope.data.promotion.bind = angular.copy(
            success.sort(function (l, r) { return l - r;})
          );
          $scope.infoMessage = "Clients/Resellers ID's verified successfully";
          return true;
        }
      });
    };

    // clear clients/resellers ID's
    $scope.clearBind = function () {
      $scope.data.promotion.bind = null;
    };

    // generate name automatically
    $scope.generateName = function () {
      if ($scope.data.promotion.bind) {
        // transform/filter array/string of ID's into array
        var bind = transformElements(angular.copy($scope.data.promotion.bind));
        if (bind.length !== 0) {
          if (bind.length > 1) {
            $scope.data.promotion.name = 'groupDiscount';
          } else {
            $scope.data.promotion.name = 'personalDiscount-' + bind[0];
          }
        }
      } else {
        $scope.data.promotion.name = 'globalDiscount';
      }
      if ($scope.data.promotion.condition) {
        $scope.data.promotion.name =
          $scope.data.promotion.name.replace(/$group|personal|global/, 'conditional');
      }
      var rules = $scope.data.promotion.rules;
      if (rules.length > 0) {
        if (rules[0].group) {
          $scope.data.promotion.name +=  '-' + rules[0].group;
        }
        if (rules[0].products.length > 0) {
          $scope.data.promotion.name += '-' + rules[0].products[0];
          if (rules[0].products.length > 1 || rules.length > 1) {
            $scope.data.promotion.name += '...';
          }
        }
        if (rules[0].discount === 'cost') {
          $scope.data.promotion.name += '-cost-price';
        } else {
          if (rules[0].discount === 'tiers') {
            $scope.data.promotion.name += '-tiers';
          } else {
            if (rules[0].discount === 'tier') {
              $scope.data.promotion.name += '-tier-' + rules[0].value;
            } else {
              $scope.data.promotion.name += '-' + rules[0].discount + '-' + rules[0].value;
            }
          }
        }
      }
    };

    // generate description automatically
    $scope.generateDescription = function () {
      var personal = false;
      if ($scope.data.promotion.bind) {
        // transform/filter array/string of ID's into array
        var bind = transformElements(angular.copy($scope.data.promotion.bind));
        if (bind.length !== 0) {
          if (bind.length > 1) {
            $scope.data.promotion.description = 'Group discount';
          } else {
            $scope.data.promotion.description = 'Personal discount for the client ' + bind[0];
            personal = true;
          }
        }
      } else {
        $scope.data.promotion.description = 'Global discount';
      }
      if ($scope.data.promotion.condition) {
        $scope.data.promotion.description =
          $scope.data.promotion.description.replace(/$group|personal|global/i, 'Conditional');
      }
      var rules = $scope.data.promotion.rules;
      if (rules.length > 0 ) {
        if (rules[0].group) {
          $scope.data.promotion.description += (personal ? ' ' : ' for the group ') +
            rules[0].group;
        }
        if (rules[0].group &&
          rules[0].products.length > 0) {
          $scope.data.promotion.description += '/' + rules[0].products[0];
          if (rules[0].products.length > 1 || rules.length > 1) {
            $scope.data.promotion.description += '...';
          }
        }
        if (rules[0].discount === 'cost') {
          $scope.data.promotion.description += ' with cost price';
        } else {
          if (rules[0].discount === 'tiers') {
            $scope.data.promotion.description += ' with tiers discount';
          } else {
            if (rules[0].discount === 'tier') {
              $scope.data.promotion.description += ' with tier discount - ' + rules[0].value;
            } else {
              $scope.data.promotion.description += ' with ' + rules[0].discount +
                ' discount - ' + rules[0].value;
            }
          }
        }
      }
    };


    // ------------
    // FORM CONTROL
    // ------------

    // save price version and price without approving
    $scope.save = function () {
      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      // check if tabs are opened
      if ($scope.tabs.length > 2) {
        $scope.errorMessage = 'Please close all opened tabs before save the promotion.';
        return;
      }

      // check if rules do not exist
      if ($scope.data.promotion.rules.length === 0) {
        $scope.errorMessage = 'Please add at least one rule into the promotion.';
        return;
      }

      isApprove = false;
      isValidForm().then( function (valid) {
        if (valid) {
          savePromotionCompletely().then( function(result) {
            if (result) {
              $modalInstance.close('saved: ' + result);
            }
          });
        }
      });

    };

    // save price version and price with approving
    $scope.approve = function () {
      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      // check if tabs are opened
      if ($scope.tabs.length > 2) {
        $scope.errorMessage = 'Please close all opened tabs before save and approve the promotion.';
        return;
      }

      // check if rules do not exist
      if ($scope.data.promotion.rules.length === 0) {
        $scope.errorMessage = 'Please add at least one rule into the promotion.';
        return;
      }

      isApprove = true;
      isValidForm().then( function (valid) {
        if (valid) {
          savePromotionCompletely().then( function(result) {
            if (result) {
              $modalInstance.close('approved: ' + result);
            }
          });
        }
      });

    };

    // cancel changes (do not apply changes)
    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    // --------------------
    // ERRORS/INFO HANDLING
    // --------------------

    // clear error message
    $scope.dismissError = function() {
      $scope.errorMessage = null;
    };

    // clear info message
    $scope.dismissInfo = function() {
      $scope.infoMessage = null;
    };

    function checkErrorCodeMessage() {
      if (userCache.get('lastErrorCode')) {
        $scope.errorMessage = 'Error: (' + userCache.get('lastErrorCode') +
          ') ' + userCache.get('lastErrorMessage') + ': ' + userCache.get('lastErrorInfo');
      } else {
        $scope.errorMessage = 'Unknown error, please check connection to service.';
      }
    }

    // watch $scope.datetime and prepare it to save
    $scope.$watch('data.promotion.bind', function(newValue) {
      if (!newValue) {
        $scope.tabs[1].title = 'Global conditions';
      } else {
        $scope.tabs[1].title = 'Personal conditions';
      }
    });

    function saveRelation() {
      var relationService = new b17Service.relations();
      return relationService.$get({
        name: $scope.data.newRelationName
      }).then(function(data) {
        var isRelationFound = data.name;
        var isNewPromo = !promotion;
        if (isRelationFound && isNewPromo) {
          $scope.errorMessage = 'A relation already exists for this id, please reopen Promo form or reload page.';
          throw Error('Relation already exits');
        }
        return Promise.resolve(data)
                      .then(updateRelation);
        });
    }

    function updateRelation(data) {
      data.name = $scope.data.newRelationName;
      data.description = 'relation counter:' + $scope.data.promotion.description;
      data.type = 'integer';
      data.multiple = false;
      data.field = data.name;
      return data.$save({token: auth.getToken()}).then(function (result) {
        if (result.name) {
          return result.name;
        } 
        checkErrorCodeMessage();
        return false;
      });
    }

    function saveCondition() {
      var conditionService = new b17Service.conditions();
      return conditionService.$get({
        name: $scope.data.newConditionName
      }).then(function(data) {
        var isConditionFound = data.name ? true : false;
        var isNewPromo = !promotion;
        if (isConditionFound && isNewPromo) {
          $scope.errorMessage = 'A condition already exists for this id, please reopen Promo form or reload page.';
          throw Error('Condition already exits');
        }
        return Promise.resolve(data)
          .then(updateCondition);
      });
    }

    function updateCondition(data) {
      data.name = $scope.data.newConditionName;
      data.description = 'condition counter:' + $scope.data.promotion.description;
      data.rules = [
        {
          relation: $scope.data.newRelationName,
          comparison: "lessThan",
          value: parseInt($scope.data.counter),
        }
      ];
      return data.$save({token: auth.getToken()}).then(function (result) {
        if (result.name) {
          return result.name;
        } 
        checkErrorCodeMessage();
        return false;
      });
    }

    function getNextPromoId(response) {
      if (!response.data || !response.data.data) {
        checkErrorCodeMessage();
        return;
      }
      var maxPromoId = 0;
      var promotions = response.data.data.results;
      promotions.forEach(function (promo) {
        maxPromoId = maxPromoId > promo.id ? maxPromoId : promo.id; 
      });
      return ++maxPromoId;
    }

    function savePromotionsObjects(id) {
      $scope.data.newRelationName = generateRelationName(id);
      $scope.data.newConditionName = generateConditionName(id);
      // if used counter for promotion
      if ($scope.data.isCounterPromo) {
        return saveRelation()
          .then(saveCondition)
          .then(savePromotion)
          .then(updateResellersRelations);
      } 
      return savePromotion()
          .then(updateResellersRelations);
    }

    function savePromotion() {
      var promotionService = new b17Service.promotions();
      if ($scope.data.promotion.id) {
        return promotionService.$get({
          id: $scope.data.promotion.id,
        }).then( updatePromotion );
      } 
      return promotionService.$create({
        token: auth.getToken(),
        version: $scope.data.promotion.version,
      }).then( updatePromotion );
    }

    function updatePromotion(data) {
      data.active = isApprove;
      data.name = $scope.data.promotion.name;
      data.description = $scope.data.promotion.description;
      // when the user selects a standard condition with a counter, 
      // the promotion is assigned a new condition that contains a counter
      data.condition = $scope.data.isCounterPromo ? $scope.data.newConditionName : $scope.data.promotion.condition;
      data.bind = angular.copy($scope.data.promotion.bind);
      if (angular.isArray(data.bind) && data.bind.length === 1) {
        data.bind = data.bind[0];
      }
      data.period = angular.copy($scope.data.promotion.period);
      data.rules = angular.copy($scope.data.promotion.rules);
      data.rules.forEach( function (item) {
        if (valueRequired.indexOf(item.discount) !== -1) {
          // value of release discount is object
          if (item.discount === 'release') {
            for(var field in item.value) {
              item.value[field] = parseFloat(item.value[field]);
            }
            return;
          }
          if (item.discount === 'markup') {
            item.value.value = parseFloat(item.value.value);
            return;
          }
          item.value = parseFloat(item.value);
        }
      });
      return data.$save({token: auth.getToken()}).then(function (result) {
        if (result.id) {
          return result.id;
        } 
        checkErrorCodeMessage();
        return false;
      });
    }

    function savePromotionCompletely() {
      return auth.checkUserData().then(function(userData) {
        if (userData.UID) {
          $scope.data.isCounterPromo = $scope.conditionType === 'Standard' && $scope.standardConditionType === 'Counter';
          if (!promotion || !promotion.id) {
            return b17Service.getPromotions({cache: false})
              .then(getNextPromoId)
              .then(savePromotionsObjects);
          }
          return Promise.resolve(promotion.id)
            .then(savePromotionsObjects);
        }
        $aside.open({
          templateUrl: 'components/auth/login-form.html',
          placement: 'right',
          size: 'sm',
          backdrop: true,
          controller: 'loginFormCtrl'
        }).result.then(function (message) {
          console.log(message);
        });
        return false;
      });
    }

    function updateResellersRelations() {
      var isCustomCounterPromo = $scope.conditionType === 'Custom' &&
                              $scope.data.promotion.condition &&
                              $scope.data.promotion.condition.indexOf('_with_counter') !== -1;
      if (!$scope.data.isCounterPromo && !isCustomCounterPromo) {
        return true;
      }
      var clientService = new b17Service.clients();
      var previousPromoBind = promotion && promotion.bind ? Array.isArray(promotion.bind) ? promotion.bind : [promotion.bind] : [];
      var promoBind = $scope.data.promotion.bind ? transformElements(angular.copy($scope.data.promotion.bind)) : [];
      var removeRelationForResellers = previousPromoBind.filter(function (value) {
        return !promoBind.includes(value);
      });
      removeRelationForResellers.forEach(function (resellerId) {
        return clientService.$get({
          id: resellerId,
        }).then( removeClientRelation );
      });
      promoBind.forEach(function (resellerId) {
        return clientService.$get({
          id: resellerId,
        }).then( updateClientRelation );
      });
      return true;
    }

    function updateClientRelation(data) {
      if (!data.relations) {
        data.relations = {};
      }
      if (data.relations[$scope.data.newRelationName] !== undefined) {
        return true;
      }
      data.relations[$scope.data.newRelationName] = 0;
      return data.$save({token: auth.getToken()}).then(function (result) {
        if (result.id) {
          return result.id;
        } 
        checkErrorCodeMessage();
        return false;
      });
    }

    function removeClientRelation(data) {
      if (data.relations[$scope.data.newRelationName] === undefined) {
        return true;
      }
      delete data.relations[$scope.data.newRelationName];
      return data.$save({token: auth.getToken()}).then(function (result) {
        if (result.id) {
          return result.id;
        } 
        checkErrorCodeMessage();
        return false;
      });
    }

    // -------
    // HELPERS
    // -------

    // generate name for relation by promotion ID
    function generateRelationName(id) {
      return 'condition_for_promo_' + id + '_with_counter';
    }

    // generate name for condition by promotion ID
    function generateConditionName(id) {
      return 'condition_for_promo_' + id + '_with_counter';
    }

    // check if form has valid values
    function isValidForm() {
      if ($scope.promotionForm.$invalid) {
        if ($scope.promotionForm.$error.required) {
          $scope.errorMessage = 'Please complete all required fields.';
        } else {
          if ($scope.promotionForm.$error.pattern) {
            $scope.errorMessage = 'Please complete all fields correctly.';
          } else {
            if ($scope.promotionForm.$error.date) {
              $scope.errorMessage = 'Invalid date/time format.';
            } else {
              if ($scope.promotionForm.$error.dateDisabled) {
                $scope.errorMessage = 'Could not change the promotion which has the date(s) in past.';
              }
            }
          }
        }
        if ($scope.errorMessage || angular.isUndefined($scope.promotionForm.$error['date-disabled'])) {
          return $q.when(false);
        }
      }

      return $scope.verifyBind();
    }

    function transformElements(elements) {
      if (!angular.isArray(elements)) {
        return elements.toString().split(/[,\s]+/)
          .filter(function (v) {
            return v.trim() !== '';
          });
      }
      return elements;
    }

    function getRuleContent(type, group) {
      var ruleContent = [];
      var keys = [];

      switch (type) {
        case "products":
          $scope.data.products.forEach( function(product) {
            if (!group || product.group === group) {
              if (angular.isUndefined(keys[product.name])) {
                keys[product.name] = true;
                ruleContent.push(product.name);
              }
            }
          });
          break;
        case "tags":
          $scope.data.products.forEach( function(product) {
            if (!group || product.group === group) {
              product.tags.forEach(function(tag){
                if (angular.isUndefined(keys[tag])) {
                  keys[tag] = true;
                  ruleContent.push(tag);
                }
              });
            }
          });
          break;
        case "providers":
          $scope.data.prices.forEach( function(price) {
            if (!group || price.group === group) {
              if (angular.isUndefined(keys[price.provider])) {
                keys[price.provider] = true;
                ruleContent.push(price.provider);
              }
            }
          });
          break;
        case "options":
          $scope.data.prices.forEach( function(price) {
            if (!group || price.group === group) {
              if (price.article.indexOf('default_') === -1 &&
                price.article.indexOf('test') === -1 &&
                price.article.indexOf('old') !== 0 &&
                angular.isUndefined(keys[price.article])) {

                keys[price.article] = true;
                ruleContent.push(price.article);
              }
            }
          });
          break;
        case "operations":
          $scope.data.config.operations.forEach( function(operation) {
            ruleContent.push(operation);
          });
      }

      return ruleContent;
    }

    $scope.fillReleaseValue = function(index) {
      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();

      $scope.tabs.forEach( function (item, idx) {
        if (item.index === index) {
          var group = item.content.group ? item.content.group : ['domains'];
          var quantity = item.content.quantity ? item.content.quantity : 1;
          var products = selector.get(item.index, 'products');
          var providers = selector.get(item.index, 'providers');
          var articles = selector.get(item.index, 'options');
          var operations = selector.get(item.index, 'operations');

          var fieldsToCheck = {
            products: products,
            providers: providers,
            articles: articles,
            operations: operations,
          };

          if (!checkRequiredFieldsToFill(fieldsToCheck)) {
            return;
          }

          var params = {
            version: 1,
            group: group,
            product: products[0],
            article: articles.length == 1 ? articles[0] : 'default',
            operation: operations.length == 1 ? operations[0] : 'create',
            quantity: quantity,
          };
          // find price by selected params (provider selected)
          if (providers.length === 1) {
            params.provider = providers[0];
            b17Service.getPrice(params).then(function (response) {
              if (response.data && response.data.data && response.data.data.total == 1) {
                setReleaseValue(response.data.data.results[0], idx);
              } else {
                checkErrorCodeMessage();
              }
            });
            return;
          }
          // find price by default product provider and params (provider is not selected)
          b17Service.getPrices({
            version: params.version,
            group: params.group,
            product: params.product,
            legacy: 'false',
          }).then(function (response) {
            if (response.data && response.data.data && response.data.data.success) {
              response.data.data.results.forEach(function(price) {
                if (
                  price.article == params.article &&
                  price.operation == params.operation &&
                  price.quantity == params.quantity &&
                  price.version == params.version
                ) {
                  setReleaseValue(price, idx);
                }
              });
            } else {
              checkErrorCodeMessage();
            }
          });
        }
      });
    };

    function setReleaseValue(price, idx) {
      var tiers = $scope.data.config.tiers;

      if (!$scope.tabs[idx].content.value) {
        $scope.tabs[idx].content.value = {};
      }

      tiers.forEach(function(tier) {
        $scope.tabs[idx].content.value[tier] = price.tier[tier];
      });
      $scope.tabs[idx].content.value.cost = price.cost;
      $scope.tabs[idx].content.value.extras = price.extras;

      var tabIndex = $scope.tabs[idx].index;

      $scope.selectGroup(tabIndex, price.group);
      $scope.tabs[idx].content.quantity = price.quantity;
      $scope.tabs[idx].content.providers = [ price.provider ];
      $scope.tabs[idx].content.operations = [ price.operations ];
      $scope.tabs[idx].content.articles = [ price.article ];

      selector.setContent(tabIndex, 'providers', getRuleContent('providers', price.group), [ price.provider ]);
      selector.setContent(tabIndex, 'operations', getRuleContent('operations', price.group), [ price.operation ]);
      selector.setContent(tabIndex, 'options', getRuleContent('options', price.group), [ price.article ]);
    }

    function checkRequiredFieldsToFill(fields) {
      if (fields.products.length !== 1) {
        $scope.errorMessage = 'Choose one product!';
        return false;
      }

      if (fields.articles.length > 1) {
        $scope.errorMessage = 'Choose one option or leave the field blank (default article: "default")!';
        return false;
      }

      if (fields.operations.length > 1) {
        $scope.errorMessage = 'Choose one operation or leave the field blank (default operation: "create")!';
        return false;
      }

      if (fields.providers.length > 1) {
        $scope.errorMessage = 'Choose one provider or leave the field blank (default product provider will be used)';
        return false;
      }
      return true;
    }

  });

})();
